import Api from "../../config/ApiConfig";
import { ISearchParam, IDataLoaderPostReq, IDataLoaderPutReq, IDeleteParams, IDataLoader, IFetchDataLoaderDetails } from "./types";
import * as functions from '../../components/shared/functions';

const apiUrls = {
    getDataLoaders: "api/v1/loaders",
    searchDataLoaders: "api/v1/searches/loaders",

}

export const getDataLoaders = (params: ISearchParam) =>
    Api.get<IDataLoader[]>(apiUrls.searchDataLoaders + "?skip=" + params.skip + "&count=" + params.count + "&orderby=" + params.orderby + "&top=" + params.top + "&queryType=full&search=" + params.search +
        functions.getParam(params.targetLayerName, "targetLayerName") + functions.getParam(params.targetLayerId, "targetLayerId") + functions.getParam(params.owner, "owner"))
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const postDataLoader = (payload: IDataLoaderPostReq) =>
    Api.post(apiUrls.getDataLoaders, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getLoaderDetails = (params: string) =>
    Api.get<IFetchDataLoaderDetails>(`${apiUrls.getDataLoaders}?batchCode=${encodeURIComponent(params)}`)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });


export const deleteLoader = (payload: IDeleteParams) =>
    Api.delete(apiUrls.getDataLoaders, { data: payload })
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const putDataLoader = (param: string, payload: IDataLoaderPutReq) =>
    Api.put(`${apiUrls.getDataLoaders}?batchCode=${encodeURIComponent(param)}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getLoaderStatus = (params: string) =>
    Api.get(`${apiUrls.getDataLoaders}/*/status?batchCode=${encodeURIComponent(params)}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });